import React from "react";
import {CircularProgress} from '@material-ui/core';



const Spinner = () =>
    <div className='spinner'>
        <CircularProgress color='secondary' />
    </div>
export default Spinner;